import type { GalleryListOptions } from '../../types/gallery';

export const galleryQueryKeys = {
  all: ['gallery'] as const,
  images: (listOptions?: GalleryListOptions) =>
    [...galleryQueryKeys.all, 'images', listOptions ?? null] as const,
  imagesRoot: () => [...galleryQueryKeys.all, 'images'] as const,
  imageData: (imageId: string) =>
    [...galleryQueryKeys.all, 'imageData', imageId] as const,
};
